export interface ComparisonRow {
  name: string;
  note: string;
  when: string;
  duration: string;
  detail: string;
}

export const comparisonRows: ComparisonRow[] = [
  {
    name: "Panoramik Röntgen",
    note: "İlk muayene, genel tarama",
    when: "Çürük / kemik taraması",
    duration: "~10 sn",
    detail: "2D genel görüntü",
  },
  {
    name: "3D Tomografi (CBCT)",
    note: "İmplant, gömülü diş, cerrahi",
    when: "Detaylı planlama",
    duration: "~9-25 sn",
    detail: "3D milimetrik kesit",
  },
  {
    name: "Sefalometrik",
    note: "Ortodontik tedavi",
    when: "Braket / şeffaf plak",
    duration: "~10 sn",
    detail: "Yan kafa filmi",
  },
  {
    name: "TME (2D)",
    note: "Çene eklemi şikâyeti",
    when: "Ağrı, klik, kilitlenme",
    duration: "~10 sn",
    detail: "Çene eklemi değerlendirmesi",
  },
  {
    name: "TME (CBCT)",
    note: "3D çene eklemi",
    when: "Kronik ağrı, cerrahi",
    duration: "~25 sn",
    detail: "3D hacimsel",
  },
  {
    name: "Bite Wing",
    note: "Dişler arası çürük",
    when: "Aproksimal çürük",
    duration: "~5 sn",
    detail: "2D interproksimal",
  },
  {
    name: "El-Bilek",
    note: "Kemik yaşı",
    when: "Büyüme-gelişim",
    duration: "~5 sn",
    detail: "2D el-bilek",
  },
];